import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ResponsibilityService {
  private http = inject(HttpClient);
  private readonly BASE_URL = (environment as any).bmwUrl || environment.accountingUrl;

  /** List all responsibilities (master) */
  list(filters: Record<string, any> = {}): Observable<any> {
    return this.http.get<any>(
      `${this.BASE_URL}/api/v1/bmw/responsibilities/`,
      { params: this.toParams(filters), withCredentials: true }
    );
  }

  /** Get a user's currently assigned responsibilities */
  getForUser(userId: string | number): Observable<any> {
    return this.http.get<any>(
      `${this.BASE_URL}/api/v1/users/${userId}/responsibilities`,
      { withCredentials: true }
    );
  }

  /**
   * Assign responsibilities to a user (backend skips duplicates).
   * IDs are sent as strings so 18-digit snowflake IDs survive transit —
   * coercing through JS Number truncates anything above 2^53.
   */
  assignToUser(userId: string | number, responsibilityIds: Array<string | number>): Observable<any> {
    return this.http.post<any>(
      `${this.BASE_URL}/api/v1/users/${userId}/responsibilities`,
      { responsibility_ids: responsibilityIds.map((id) => String(id)) },
      { withCredentials: true }
    );
  }

  /** Soft-delete a single user-responsibility mapping */
  removeFromUser(userId: string | number, responsibilityId: string | number): Observable<any> {
    return this.http.delete<any>(
      `${this.BASE_URL}/api/v1/users/${userId}/responsibilities/${responsibilityId}`,
      { withCredentials: true }
    );
  }

  private toParams(filters: Record<string, any>): HttpParams {
    let params = new HttpParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.set(key, String(value));
      }
    });
    return params;
  }
}
